import { render, staticRenderFns } from "./CreateOccupation.vue?vue&type=template&id=5707a502&scoped=true&"
import script from "./CreateOccupation.vue?vue&type=script&lang=js&"
export * from "./CreateOccupation.vue?vue&type=script&lang=js&"
import style0 from "./CreateOccupation.vue?vue&type=style&index=0&id=5707a502&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5707a502",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormSelect: require('/workspace/components/Form/FormSelect.vue').default})
